import React, { useState, useEffect } from 'react';
import classNames from 'classnames';

import { ACCOUNT_SETTINGS_PAGES } from '../../routeConfiguration';
import { FormattedMessage } from '../../util/reactIntl';
import { ensureCurrentUser } from '../../util/data';
import {
  InlineTextButton,
  Logo,
  Menu,
  MenuLabel,
  MenuContent,
  MenuItem,
  NamedLink,
  IconAccount
} from '../../components';

import css from './TopbarDesktop.css';
import CategoryBar from './CategoryBar';

const TopbarDesktop = props => {
  const {
    className,
    currentUser = null,
    currentPage = null,
    rootClassName,
    currentUserProviderId,
    notificationCount = 0,
    intl,
    isAuthenticated,
    onLogout,
    onDktLogin,
    cartLink,
    isWhiteTopbar,
    isSearchPage
  } = props;
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const authenticatedOnClientSide = mounted && isAuthenticated;

  const classes = classNames(rootClassName || css.root, className, { [css.hp]: currentPage === '/' }, { [css.whiteTopbar]: isWhiteTopbar });

  const user = ensureCurrentUser(currentUser);

  const isOfferEnabled = user.attributes.hasProvider || user.attributes.isAdmin;

  const search = <div className={css.searchLink}></div>;

  const notificationDot = notificationCount > 0 ? <div className={css.notificationDot} /> : null;

  const inboxLink = authenticatedOnClientSide ? (
    <NamedLink
      className={css.inboxLink}
      name="InboxPage"
      params={{ tab: currentUserProviderId ? 'sales' : 'orders', providerId: currentUserProviderId || 'orders' }}
    >
      <span className={css.inbox}>
        <FormattedMessage id="TopbarDesktop.inbox" />
        {notificationDot}
      </span>
    </NamedLink>
  ) : null;

  const currentPageClass = page => {
    const isAccountSettingsPage =
      page === 'AccountSettingsPage' && ACCOUNT_SETTINGS_PAGES.includes(currentPage);
    return currentPage === page || isAccountSettingsPage ? css.currentPage : null;
  };

  const profileMenu = authenticatedOnClientSide ? (
    <Menu>
      <MenuLabel className={css.profileMenuLabel} isOpenClassName={css.profileMenuIsOpen}>
        <IconAccount />
      </MenuLabel>
      <MenuContent className={css.profileMenuContent}>
        <MenuItem key="Info">
          <div className={css.userWrapper}>
            <div className={css.name}>{`${currentUser?.attributes.firstName}  ${currentUser?.attributes.lastName}`}</div>
            <div className={css.email}>{currentUser?.attributes.email}</div>
          </div>
          <span className={css.menuItemBorder} />
        </MenuItem>
        {
          isOfferEnabled ?
            <MenuItem key="ManageListingsPage">
              <NamedLink
                className={classNames(css.yourListingsLink, currentPageClass('ManageListingsPage'))}
                name="ManageListingsPage"
                params={{ providerId: currentUserProviderId || 'orders' }}
              >
                <span className={css.menuItemBorder} />
                <FormattedMessage id="TopbarDesktop.yourListingsLink" />
              </NamedLink>
            </MenuItem> : null
        }
        <MenuItem key="ProfileSettingsPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('ProfileSettingsPage'))}
            name="ProfileSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.profileSettingsLink" />
          </NamedLink>
        </MenuItem>
        <MenuItem key="InvoiceSettingsPage">
          <NamedLink
            className={classNames(css.profileSettingsLink, currentPageClass('InvoiceSettingsPage'))}
            name="InvoiceSettingsPage"
          >
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.invoiceSettingsLink" />
          </NamedLink>
        </MenuItem>
        {authenticatedOnClientSide && (currentUser?.attributes.adminForCountries?.length > 0 || currentUser?.attributes.isAdmin) ?
          <MenuItem key="ConsoleTransactionPage">
            <NamedLink
              className={classNames(css.consoleLink, currentPageClass('ConsoleTransactionPage'))}
              name="ConsoleTransactionPage"
            >
              <span className={css.menuItemBorder} />
              <FormattedMessage id="TopbarDesktop.consoleLink" />
            </NamedLink>
          </MenuItem> : null
        }
        {authenticatedOnClientSide && (currentUser?.attributes.hasProvider || currentUser?.attributes.isAdmin) ?
          <MenuItem key="NewListingPage" className={css.createListingItem}>
            <NamedLink className={css.createListingLink} name="NewListingPage">
              <span className={css.createListing}>
                <FormattedMessage id="TopbarDesktop.createListing" />
              </span>
            </NamedLink>
          </MenuItem> : null
        }
        <MenuItem key="logout">
          <InlineTextButton rootClassName={css.logoutButton} onClick={onLogout}>
            <span className={css.menuItemBorder} />
            <FormattedMessage id="TopbarDesktop.logout" />
          </InlineTextButton>
        </MenuItem>
      </MenuContent>
    </Menu>
  ) : null;

  const dktLink = !authenticatedOnClientSide ? (
    <a className={css.loginLink} onClick={() => onDktLogin()}>
      <span className={css.login}>
        <FormattedMessage id="TopbarDesktop.login" />
      </span>
    </a>
  ) : null;

  return (
    <>
      <nav className={classes}>
        <NamedLink className={css.logoLink} name="LandingPage">
          <Logo
            format="desktop"
            className={css.logo}
            alt={intl.formatMessage({ id: 'TopbarDesktop.logo' })}
          />
        </NamedLink>
        {search}
        {inboxLink}
        {cartLink}
        {profileMenu}
        {dktLink}
      </nav>
      <CategoryBar isLandingPage={!isSearchPage} />
    </>
  );
};

export default TopbarDesktop;
